 
    <template>
        <div id="app">
          <!-- 新增头部 -->
          <header class="header">
            学生信息报备系统
            <button @click="close()" class="logout-btn">退出当前登录</button>
          </header>
          <!-- 新增侧边栏 -->
          <aside class="sidebar">
            <ul>
              <button @click="back()">学生管理</button>
              <button>用户管理</button>
            </ul>
          </aside>
        <!-- 主体内容区域 -->
        <main>
        <button @click="addNewRecord">新增</button>
        <table> 
          <thead>  
            <tr>  
              <th>姓名</th>  
              <th>用户名</th>  
              <th>密码</th>  
              <th>手机号</th>
              <th>用户级别</th> 
              <th v-if="status===1">录入数量</th>
              <th>账号状态</th>
              <th>操作</th>  
            </tr>  
          </thead>  
          <tbody>  
            <tr v-for="(record, index) in records" :key="index">  
              <td>{{ record.name }}</td>  
              <td>{{ record.username }}</td>  
              <td>{{ record.password }}</td>  
              <td>{{ record.phone }}</td> 
              <td>{{ record.status }}</td>   
              <td v-if="status===1">{{ record.userNum }}</td>
              <td v-if="record.licence===1">启用中</td>
              <td v-else>禁用中</td>
              <td>  
                <button @click="editRecord(index)">修改</button>  
                <button @click="deleteRecord(index)">删除</button> 
                <button v-if="status===1&&record.licence===0" @click="startForbidden(index)">启用</button> 
                <button v-if="status===1&&record.licence===1" @click="startForbidden(index)">禁用</button>  
              </td>  
            </tr>  
          </tbody>   
            </table>
          </main>
        </div>
  </template>
    <script>  
     import axios from 'axios';  
     
    export default {  
      
      data() {  
        return {  
          page:1,
          pageSize:10,
          username:JSON.parse(localStorage.getItem("username")),
          status:JSON.parse(localStorage.getItem("status")),
          records: []  
        };  
      },  
      methods: { 
        close(){
          localStorage.clear();
          this.$router.push({ name: 'Login'});
        },
        back(){
            this.$router.push({ name: 'Show'});
        },
        addNewRecord() {  
          this.$router.push({ name: 'UserSubmitSave'});  
          console.log('添加新记录');  
        },  
        editRecord(index) {  
          console.log('编辑记录：', this.records[index].id);  
          this.$router.push({ name: 'UserSubmitUpdate', 
          query: {
                  id:this.records[index].id
                } });  
        },  
        deleteRecord(index) {  
          axios.delete(`http://39.100.109.86:8093/user/${this.records[index].id}`,{
            params: {  
              username:this.username
            }  
          })
            .then(response => {  
            if(response.data.code===1){
              alert("删除成功")
              
            }else{
              alert(response.data.msg)
            }
            location.reload();
            })  
            .catch(error => {  
              console.error(error);  
            });
        },
        startForbidden(index){
          axios.post(`http://39.100.109.86:8093/user/status/${this.records[index].licence}?id=${this.records[index].id}&username=${this.records[index].username}`)
          .then(response => {  
            //location.reload();
            console.log(response.data); 
            if(response.data.code===1){
              alert("修改成功")
              
            }else{
              alert(response.data.msg)
            }
            location.reload();
          })  
          .catch(error => {  
            console.error(error);  
          }); 
        }
      } ,
     mounted() {
      axios.get('http://39.100.109.86:8093/user/page', {
      params: {  
        username:this.username
      }  
      })  
      .then(response => {  
        this.records=response.data.data;
        console.log(response.data.data);  
      })  
      .catch(error => {  
        console.error(error);  
      });
    }
    };  
    </script>  
      
    <style>  
    /* 添加一些简单的样式 */  
    #app {  
      font-family: Avenir, Helvetica, Arial, sans-serif;  
      text-align: center;  
      color: #2c3e50;  
      margin-top: 60px;  
    }  
      
    table {  
      margin-top: 20px;  
      border-collapse: collapse;  
      width: 100%;  
    }  
      
    th, td {  
      text-align: left;  
      padding: 8px;  
      border-bottom: 1px solid #ddd;  
    }  
      
    tr:hover {background-color: #f5f5f5;}  
      
    button {  
      margin: 0 5px;  
      padding: 5px 10px;  
      border: none;  
      background-color: white;  
      color: #3378C2;  
      cursor: pointer;  
    }  
      
    button:hover {  
      background-color: #009FCC;  
    }  
    /* 新增头部样式 */
    .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
    text-align: left;
    /* color: #F3FFF7;  */
    /* background-color: #647587; */
    background-color: #396386;
    padding: 10px 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .nav ul {
    list-style-type: none;
    padding: 0;
    display: flex;
  }
  
  
  .nav a {
    text-decoration: none;
    color: #333;
    transition: color 0.3s;
  }
  
  .nav a.active {
    color: #007bff;
  }
  
  /* 侧边栏颜色调整与头部一致，并添加触达反馈 */
  .sidebar {
    position: fixed;
    top: 60px; /* 与头部底部对齐 */
    bottom: 0;
    left: 0;
    width: 150px;
    background-color: #0e141a;
    /* background: #333333; 与头部颜色一致 */
    padding: 20px;
    transition: background-color 0.3s; /* 平滑过渡 */
  }
  
  
  /* 为适应头部固定，调整主体内容的上边距 */
  
  .sidebar ul {
    list-style-type: none;
    padding: 0;
  }
  
  .sidebar li {
    margin-bottom: 10px;
    background-color: #ced3d8;
  }
  
  .sidebar a {
    text-decoration: none;
    color: #333;
    /* color: #1F1F1F; */
    display: block;
    transition: color 0.3s;
  }
  
  .sidebar a.active {
    color: #007bff;
    font-weight: bold;
  }
  /* 侧边栏样式调整 */
  .sidebar {
    /* ...现有样式... */
    display: flex;
    flex-direction: column; /* 使内容垂直排列 */
    justify-content: space-between; /* 在按钮间创建均匀间距 */
  }
  
  .sidebar button {
    width: 100%; /* 让所有按钮宽度相同，适应侧边栏宽度 */
    margin-top: 10px;
    background-color: #444444;
    color: white;
    text-align: left; /* 文本左对齐，可根据需要调整 */
    font-size: 25px;
    font-weight: 500;
  }
  
  
  /* 确保主体内容不被侧边栏覆盖 */
  main {
    margin-left: 200px; /* 与侧边栏宽度相同 */
    padding: 20px;
  }
  /* 为表格标题增加一些色彩 */
  thead tr {
    background-color: #f8f9fa;
  }
  
  /* 为表格行添加 hover 效果 */
  tbody tr:hover {
    background-color: #e9ecef;
  }
  
  /* 增加按钮和链接的悬停效果 */
  .nav a:hover, .sidebar a:hover, button:hover {
    opacity: 0.8;
  }
  
  /* 可选：为侧边栏添加背景渐变色，增加视觉层次 */
  .sidebar {
    /* background: linear-gradient(to bottom, #f8f9fa 0%, #e9ecef 100%); */
    background-color: #444444;
  }
  
  /* 其他样式保持不变 */
  
  .logout-btn {
    position: absolute;
    top: 10px; /* 调整以适应顶部距离 */
    right: 20px; /* 设置右边距，使其靠右 */
    background-color: #396386; /* 或您选择的颜色 */
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px; /* 可选，给按钮添加圆角 */
  }
  
  .logout-btn:hover {
    background-color: #009FCC; /* 鼠标悬停时改变颜色 */
  }
  
    </style>